import { render, staticRenderFns } from "./FansTable.vue?vue&type=template&id=d0a6bca6&"
import script from "./FansTable.vue?vue&type=script&lang=js&"
export * from "./FansTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports